import PageWrapper from "../../../../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import UserView from "../../../../../components/admin/users/view/UserView";

const AdminUserEdit = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("t.page.user.admin.view")}>
      <UserView />
    </PageWrapper>
  );
};

export default AdminUserEdit;
